export const DEFAULT_CATEGORIES_COUNT = 13;
